module.exports = __webpack_public_path__ + "static/media/30OIOS5.d4c40b38.jpg";